import { render, staticRenderFns } from "./DetailsDialog.vue?vue&type=template&id=a8c97bb6"
import script from "./DetailsDialog.vue?vue&type=script&lang=js"
export * from "./DetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./DetailsDialog.vue?vue&type=style&index=0&id=a8c97bb6&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports